import {
  JOB_ADDED,
  JOB_CANCEL,
  JOB_CANCELLED,
  JOB_QUEUED,
  JOB_STARTED,
  JOB_STOP,
  JOB_UPDATED,
  READ_ALL_JOBS,
  READ_JOB,
  SET_STOP_JOB,
} from './constants';

export function jobAdded(args) {
  return {
    type: JOB_ADDED,
    payload: args,
  };
}

export function jobUpdated(args) {
  return {
    type: JOB_UPDATED,
    payload: args,
  };
}

export function jobCancelled(args) {
  return {
    type: JOB_CANCELLED,
    payload: args,
  };
}

export function jobQueued(args) {
  return {
    type: JOB_QUEUED,
    payload: args,
  };
}

export function jobCancel(args) {
  return {
    type: JOB_CANCEL,
    payload: args,
  };
}

export function jobStop(args) {
  return {
    type: JOB_STOP,
    payload: args,
  };
}

export function setStopJobId(args) {
  return {
    type: SET_STOP_JOB,
    payload: args,
  };
}

export function jobStarted(args) {
  return {
    type: JOB_STARTED,
    payload: args,
  };
}

export function readJob(args) {
  return {
    type: READ_JOB,
    payload: args,
  };
}

export function readAllJobs(args) {
  return {
    type: READ_ALL_JOBS,
    payload: args,
  };
}
